import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import SafeHtml from "@lhd/components/SafeHtml";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
}

const LabelField = (props: IProps) => {
  const { item, style } = props;
  const { labelText } = getConfigAppPartType(item);

  return (
    <div
      className="label_container"
      key={item.id}
      id={item.id}
      data-grid={item.item_config_data}
      style={{
        background: "#fff",
        color: "black",
        padding: "0 5px",
        ...style,
      }}
    >
      <SafeHtml html={labelText || ""} />
    </div>
  );
};
export default LabelField;
